/**
 * Created by jjing on 6/8/2017.
 */

const GlobalConstants={
    STATUS:{
        init: "_init",
        trying: "_trying",
        done: "_done",
        error: "_error",
        deleting: '_deleting'
    },
    SessionStoreKey:{
        Permission: "UserProfilePermission"
    },
    Service:{
        localUser: {
            "key": "user-local-user",
            "ver": "1"
        },
        vault: {
            "key": "vault",
            "ver": "1.0"
        },
        orionUserAuth: {
            "key": "user-auth-login",
            "ver": "1"
        },
        userProvisioning: {
            "key": "user-auth-provisioning",
            "ver": "1"
        },
        userInfo: {
            "key": "user-info",
            "ver": "1"
        },
        deviceMessaging: {
            "key": "device-messaging-client",
            "ver": "1.0"
        }
    }
}

export const OPERATOR_TYPES = {
    lt: '&lt;',
    gt: '&gt;',
    lte: '&le;',
    gte: '&ge;',
    neq: '&ne;',
    eq: "="
};

export const PRODUCT_SHOW_NAME = {
    "Polycom Pano App for Win": "Polycom Pano App for Win",
    "Polycom Pano App for Mac": "Polycom Pano App for Mac",
    "Pano": "Pano",
    "Polycom RealConnect Relay": "Polycom Cloud Relay",
    "Polycom RealConnect Relay: Calendar Relay": "Polycom Cloud Relay: Calendar Relay",
    "Polycom RealConnect Relay: Hybrid": "Polycom Cloud Relay: RealConnect Hybrid",
    "PDMS: Download Agent": "Polycom Cloud Relay: PDMS: Download Agent",
    "PDMS: Management Agent": "Polycom Cloud Relay: PDMS: Management Agent",
    "Polycom_Cloud_Relay_Control": "Polycom Cloud Relay: Control",
    "Polycom_Cloud_Relay_Proxy": "Polycom Cloud Relay: Proxy",
    "Polycom_CR_Signalling_Adapter": "Polycom RealConnect SIP Adapter"
}

export const POLICY_TRANSPORTS = {
    "https": "File-server(HTTPS)",
    "container-registry": "Container Registry"
};

export const SERVICE_ID_LIST = [
    "auth-device-pholio",
    "auth-user-pholio",
    "device-app-tokens",
    "device-auth-mtls",
    "device-auth-tokens",
    "device-location",
    "device-proxy-client",
    "device-proxy-device",
    "device-registry",
    "device-tenant-discovery",
    "device-tenant-provisioning",
    "directory",
    "document",
    "global-directory",
    "orchestration",
    "remoter",
    "remoter-controller",
    "session-manager",
    "sm-content",
    "softupdate-global-policy",
    "softupdate-tenant-policy",
    "tenant-manager",
    "user-access-control",
    "user-add-oauth-resource",
    "user-app-tokens",
    "user-auth-login",
    "user-auth-provisioning",
    "user-info",
    "user-local-user",
    "user-query-oauth-resource",
    "user-tenant-discovery"
]

export const Lock_Status = {
    lock_lock: "_lock_lock",
    lock_free: "_lock_free",
    lock_Empty: "_lock_Empty"
};

export const LangOptions = {
    'en-US': {label: "American English", value: "en-US"},
    'en-GB': {label: "British English", value: "en-GB"},
    'zh-CN': {label: "简体中文", value: "zh-CN"},
    'zh-TW': {label: "繁體中文", value: "zh-TW"},
    'fr': {label: "Français", value: "fr"},
    'de': {label: "Deutsch", value: "de"},
    'ja': {label: "日本語", value: "ja"},
    'ko': {label: "한국어", value: "ko"},
    'es': {label: "Español", value: "es"},
    'ru': {label: "Русский", value: "ru"},
    'pt': {label: "Português", value: "pt"},
    'ar': {label: "العربية", value: "ar"},
    'hu': {label: "Magyar", value: "hu"},
    'it': {label: "Italiano", value: "it"},
    'pl': {label: "Polski", value: "pl"},
    'no': {label: "Norsk", value: "no"}
};

export const Permissions = {
    TenantManager: {
        SHOW: "tenant-manager/list",
        ADD: "tenant-manager/create",
        DELETE: "tenant-manager/delete",
        UPDATE: "tenant-manager/update"
    },
    SoftwareUpgrade: {
        SHOW: ["sofupdate-global-policy/list", "PDMS_Get_Tenant", "PDMS_Get_Device_Image"],
        ADD: ["sofupdate-global-policy/edit", "PDMS_Update_Device_Image"],
        DELETE: ["sofupdate-global-policy/edit", "PDMS_Update_Device_Image"],
        EDIT: ["sofupdate-global-policy/edit", "PDMS_Update_Device_Image"]
    },
    MultiTenant: {
        SHOW: "multi-tenant-services/list",
        SCALE: "multi-tenant-services/scale"
    },
    SystemUsage: {
        SHOW: "system-resource-usage/view",
        CONFIG: "system-resource-usage/update-thresholds"
    },
    Diagnostics: {
        SHOW: "diagnostics/log-downloader"
    },
    User: {
        SHOW: ["GET_UsersWithRole", "GET_AllUserLocalProfiles"],
        ADD: "POST_UserLocalCreate",
        EDIT: ["PUT_UserProfile", "PUT_UserLocalProfile", "PATCH_UserPermissions", "PATCH_UserRoles"],
        DELETE: "DELETE_RoleFromUsers"
    },
    AppVault: {
        SHOW: ['vault/readall', 'vault/read'],
        ADD: ['vault/write'],
        EDIT: ['vault/write'],
        DELETE: ['vault/write']
    },
    PDMS: {
        SHOW: ['PDMS_Get_System_Configuration', 'PDMS_Update_System_Configuration']
    },
    Temp: []
}

export const RolePermissions = {
    Operator: [
        Permissions.SoftwareUpgrade.SHOW,
        Permissions.Diagnostics.SHOW,
        Permissions.MultiTenant.SHOW,
        Permissions.SystemUsage.SHOW,
        Permissions.TenantManager.SHOW
    ],
    SoftwareAdmin: [
        Permissions.SoftwareUpgrade.SHOW,
        Permissions.SoftwareUpgrade.ADD,
        Permissions.SoftwareUpgrade.EDIT,
        Permissions.SoftwareUpgrade.DELETE
    ],
    ServiceAdmin: [
        Permissions.AppVault.SHOW,
        Permissions.AppVault.ADD,
        Permissions.AppVault.EDIT,
        Permissions.AppVault.DELETE,
        Permissions.TenantManager.SHOW,
        Permissions.TenantManager.ADD,
        Permissions.TenantManager.DELETE,
        Permissions.TenantManager.UPDATE,
        Permissions.MultiTenant.SHOW,
        Permissions.MultiTenant.SCALE,
        Permissions.SystemUsage.SHOW,
        Permissions.SystemUsage.CONFIG,
        Permissions.Diagnostics.SHOW,
        Permissions.PDMS.SHOW
    ],
    UserAdmin: [
        Permissions.User.SHOW,
        Permissions.User.ADD,
        Permissions.User.EDIT
    ]
}

export const UserRole = {
    Operator: {label: "Operator", value: "Operator"},
    SoftwareAdmin: {label: "Software Administrator", value: "SoftwareAdmin"},
    ServiceAdmin: {label: "Service Administrator", value: "ServiceAdmin"},
    UserAdmin: {label: "User Administrator", value: "UserAdmin"}

}

export const NameColors = ["#913e6f", "#faa43e", "#128ba4", "#704d88", "#519b90"];

export const Threshold = {
    error: 50,
    fatal: 70
};

export default GlobalConstants;


// WEBPACK FOOTER //
// ./src/commons/Constants.js